// cleanup_convert_to_typescript_file_GENERICS

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import MobileGridContext from '../logic/MobileGridContext';
import useStyles from './DefinitionList.styles.ts';

const DefinitionList = ({ columns, rowData, rowId }) => {
  const { dd, dt, root } = useStyles();
  const gridContext = React.useContext(MobileGridContext);
  return (
    <dl className={root}>
      {columns.map((col) => {
        // If there is a condition to check whether this should show or not
        const shouldShow = col?.condition
          ? col.condition({
              data: rowData,
              gridContext,
              conditions: gridContext.columnConditions
            })
          : true;
        if (!shouldShow) return null;
        return (
          <Fragment key={`frag_${col?.field}_${rowId}`}>
            <dt key={`dt_${col?.fieldId}_${rowId}`} className={dt}>
              {col?.headerDisplay ? col?.headerDisplay({ column: col, rowData }) : col?.headerName}
            </dt>
            <dd col-id={col?.field} key={`dd_${col?.fieldId}_${rowId}`} className={dd}>
              {col?.cellDisplay ? col?.cellDisplay({ rowData, column: col }) : rowData[col?.field]}
            </dd>
          </Fragment>
        );
      })}
    </dl>
  );
};

DefinitionList.propTypes = {
  rowData: PropTypes.shape({}).isRequired,
  rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default DefinitionList;
